import { useAppStore } from '@/stores/AppStore'

export function useGetConfigVar(featureName) {
  const appStore = useAppStore()

  const configVars = appStore.configVars

  if (!(featureName in configVars)) {
    throw new Error(`Feature "${featureName}" is not defined in feature flags`)
  }

  return configVars[featureName]
}

export function useGetVerificationMethods() {
  const featureFlag = useGetConfigVar('ENGINEER_APP_VERIFICATION_METHODS')

  const methods = []

  if (!featureFlag || typeof featureFlag !== 'object') {
    return methods
  }

  Object.entries(featureFlag).forEach(([method, enabled]) => {
    if ((method === 'EMAIL' || method === 'SMS') && enabled) {
      methods.push(method)
    }
  })

  return methods
}
